/*
  Macala · Pack builder para Stiletto (<macala-pack-builder>).
  Patrón: "Elige tu formato" (tarjetas) + "Tu pack" (huecos) + ventana de color y talla (<dialog>).
  Cada color es un producto: en cada hueco, el color elige el producto hermano y la talla su variante.
  Con "Unidad" (1) no se usa el pack: se ocultan los huecos y se muestra la compra nativa de la ficha
  (selector de talla, guía de tallas y botón del tema). Con 2 o más, al revés.
  JS vanilla, sin librerías. El marcado lo pinta snippets/macala-pack-builder.liquid.
*/
(function () {
  'use strict';

  if (window.customElements.get('macala-pack-builder')) return;

  var formatters = {};

  function money(cents, currency) {
    var whole = Math.round(cents) % 100 === 0;
    var key = (currency || 'EUR') + (whole ? ':0' : ':2');
    if (!formatters[key]) {
      formatters[key] = new Intl.NumberFormat('es-ES', {
        style: 'currency',
        currency: currency || 'EUR',
        minimumFractionDigits: whole ? 0 : 2,
        maximumFractionDigits: whole ? 0 : 2
      });
    }
    return formatters[key].format(Math.round(cents) / 100);
  }

  function shortId() {
    var chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
    var bytes = new Uint8Array(8);
    if (window.crypto && window.crypto.getRandomValues) {
      window.crypto.getRandomValues(bytes);
    } else {
      for (var i = 0; i < bytes.length; i++) bytes[i] = Math.floor(Math.random() * 256);
    }
    var out = '';
    for (var j = 0; j < bytes.length; j++) out += chars[bytes[j] % chars.length];
    return out;
  }

  function routeRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* Modo Unidad: oculta la parte del pack (huecos, precio, botón y notas) y deja solo las tarjetas de formato. */
  function ensureSingleStyle() {
    if (document.getElementById('mpb-single-style')) return;
    var style = document.createElement('style');
    style.id = 'mpb-single-style';
    style.textContent =
      '.mpb.is-single .mpb__pack-head,.mpb.is-single .mpb__slots,.mpb.is-single .mpb__price,' +
      '.mpb.is-single .mpb__cta,.mpb.is-single .mpb__error,.mpb.is-single .mpb__note{display:none !important;}';
    document.head.appendChild(style);
  }

  /* Contenedores de la columna de producto de Stiletto y lo que se oculta dentro. Revisar en el tema real. */
  var COLUMN_SELECTOR = '[data-product-blocks], .product__blocks, .product__primary-right';
  /* Stiletto de Macala: colores entre productos, selector de talla y formulario de compra (incluye la barra fija). */
  var NATIVE_SELECTOR = '[data-color-group-swatches], .product__variants-wrapper, form[data-product-form]';
  /* Bloque de la ficha con el precio para suscriptores: se oculta con packs de 2 o más (no se combinan). */
  var KLAVIYO_SELECTOR = '.custom-klaviyo-wrapper';
  var SECTION_SELECTOR = '.shopify-section, section';

  function hideEl(el) {
    if (el.hasAttribute('data-mpb-hidden')) return;
    el.setAttribute('data-mpb-prev-style', el.getAttribute('style') || '');
    el.hidden = true;
    /* Estilo en línea con !important: el atributo hidden lo pisaría un display del tema. */
    el.style.setProperty('display', 'none', 'important');
    el.setAttribute('data-mpb-hidden', '');
  }

  function showEl(el) {
    if (!el.hasAttribute('data-mpb-hidden')) return;
    var prev = el.getAttribute('data-mpb-prev-style');
    if (prev) el.setAttribute('style', prev);
    else el.removeAttribute('style');
    el.hidden = false;
    el.removeAttribute('data-mpb-prev-style');
    el.removeAttribute('data-mpb-hidden');
  }

  function $(root, selector) { return root.querySelector(selector); }
  function $$(root, selector) { return Array.prototype.slice.call(root.querySelectorAll(selector)); }

  class MacalaPackBuilder extends HTMLElement {
    connectedCallback() {
      if (this._mpbReady) return;
      var dataEl = $(this, 'script[data-mpb-json]');
      if (!dataEl) return;
      try {
        this.data = JSON.parse(dataEl.textContent);
      } catch (error) {
        console.warn('[macala-pack-builder] JSON de datos no válido', error);
        return;
      }
      this._mpbReady = true;

      var data = this.data;
      this.currency = data.currency || 'EUR';
      this.products = data.products || [];
      this.hasSize = !!data.hasSize;
      this.tiers = (data.tiers || [])
        .filter(function (t) { return t && t.qty > 0 && t.price > 0; })
        .sort(function (a, b) { return a.qty - b.qty; });
      this.anchorUnit = data.anchorUnit || (this.tiers[0] ? Math.round(this.tiers[0].price / this.tiers[0].qty) : 0);
      this.currentIndex = Math.max(0, this.products.findIndex(function (p) { return p.id === data.currentId; }));

      this.tierEls = $$(this, '[data-mpb-tier]');
      this.slotEls = $$(this, '[data-mpb-slot]');
      this.cta = $(this, '[data-mpb-cta]');
      this.errorEl = $(this, '[data-mpb-error]');
      this.countEl = $(this, '[data-mpb-count]');
      this.totalEl = $(this, '[data-mpb-total]');
      this.anchorEl = $(this, '[data-mpb-anchor]');
      this.savingEl = $(this, '[data-mpb-saving]');
      this.perUnitEl = $(this, '[data-mpb-per-unit]');
      this.codesNoteEl = $(this, '[data-mpb-codes-note]');
      this.dialog = $(this, '[data-mpb-dialog]');

      var checked = $(this, '[data-mpb-tier][aria-checked="true"]');
      this.qty = checked ? Number(checked.dataset.qty) : (this.tiers[0] ? this.tiers[0].qty : 1);

      /* Hueco 1: producto actual; talla de la variante de la URL solo si el formato inicial es Unidad. */
      var initialSize = this.qty === 1 && data.initialSize ? data.initialSize : null;
      this.slots = this.slotEls.map(function (_el, i) {
        return i === 0 ? { product: this.currentIndex, size: initialSize } : { product: null, size: null };
      }, this);
      this.normalize(this.slots[0]);
      this.busy = false;
      this.nextHint = -1;
      this.hiddenNative = [];

      this.onClick = this.onClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onDialogClose = this.onDialogClose.bind(this);
      this.onDialogClick = this.onDialogClick.bind(this);
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeydown);
      if (this.dialog) {
        this.dialog.addEventListener('close', this.onDialogClose);
        this.dialog.addEventListener('click', this.onDialogClick);
      }

      ensureSingleStyle();
      this.render();
      if (document.readyState === 'loading') {
        /* La compra nativa y el bloque de Klaviyo pueden venir después del builder en el HTML. */
        document.addEventListener('DOMContentLoaded', function () {
          this.syncNative();
          this.toggleKlaviyo(this.qty >= 2);
        }.bind(this), { once: true });
      }
      this.setAttribute('data-mpb-ready', '');
    }

    disconnectedCallback() {
      if (!this._mpbReady) return;
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKeydown);
      if (this.dialog) {
        this.dialog.removeEventListener('close', this.onDialogClose);
        this.dialog.removeEventListener('click', this.onDialogClick);
      }
      this.restoreNative();
      this.toggleKlaviyo(false);
      this._mpbReady = false;
    }

    /* ---------- Compra nativa del tema y bloque de Klaviyo ---------- */

    /* Unidad: compra nativa visible (talla, guía de tallas y botón). Pack: compra nativa oculta. */
    syncNative() {
      if (!this._mpbReady || !this.hasAttribute('data-mpb-hide-native')) return;
      if (this.qty === 1) this.restoreNative();
      else this.hideNative();
    }

    /* Oculta la compra nativa de la misma sección (nunca la vista rápida ni otras secciones). */
    hideNative() {
      if (!this._mpbReady) return;
      if (!this.hiddenNative) this.hiddenNative = [];
      var scope = this.closest(SECTION_SELECTOR);
      if (!scope) return;
      var self = this;
      scope.querySelectorAll(NATIVE_SELECTOR).forEach(function (el) {
        if (self.contains(el) || el.closest('[data-quick-view-modal]')) return;
        if (el.hasAttribute('data-mpb-hidden')) return;
        hideEl(el);
        self.hiddenNative.push(el);
      });
    }

    restoreNative() {
      (this.hiddenNative || []).forEach(showEl);
      this.hiddenNative = [];
    }

    klaviyoBlocks() {
      var scope = this.closest(COLUMN_SELECTOR);
      var found = scope ? scope.querySelectorAll(KLAVIYO_SELECTOR) : [];
      if (!found.length) {
        scope = this.closest(SECTION_SELECTOR);
        found = scope ? scope.querySelectorAll(KLAVIYO_SELECTOR) : [];
      }
      var self = this;
      return Array.prototype.filter.call(found, function (el) { return !self.contains(el); });
    }

    toggleKlaviyo(isPack) {
      this.klaviyoBlocks().forEach(function (el) {
        if (isPack) hideEl(el);
        else showEl(el);
      });
    }

    /* ---------- Estado ---------- */

    variantOf(productIndex, size) {
      var product = this.products[productIndex];
      if (!product) return null;
      if (!this.hasSize) return product.variants[0] || null;
      return product.variants.find(function (v) { return v.size === size; }) || null;
    }

    sizeAvailable(productIndex, size) {
      var variant = this.variantOf(productIndex, size);
      return !!(variant && variant.available);
    }

    productAvailable(productIndex) {
      var product = this.products[productIndex];
      return !!product && product.variants.some(function (v) { return v.available; });
    }

    /* Vacía la talla si no hay stock en ese color; si el color solo tiene una talla con stock, la elige. */
    normalize(slot) {
      if (!slot || slot.product == null || !this.hasSize) return;
      if (slot.size && !this.sizeAvailable(slot.product, slot.size)) slot.size = null;
      var product = this.products[slot.product];
      if (!slot.size && product && product.variants.length === 1 && product.variants[0].available) {
        slot.size = product.variants[0].size;
      }
    }

    isComplete(slot) {
      if (!slot || slot.product == null) return false;
      var variant = this.variantOf(slot.product, slot.size);
      return !!(variant && variant.available);
    }

    doneCount() {
      var n = 0;
      for (var i = 0; i < this.qty; i++) if (this.isComplete(this.slots[i])) n++;
      return n;
    }

    firstIncomplete() {
      for (var i = 0; i < this.qty; i++) if (!this.isComplete(this.slots[i])) return i;
      return -1;
    }

    currentTier() {
      var qty = this.qty;
      return this.tiers.find(function (t) { return t.qty === qty; }) || this.tiers[0];
    }

    setQty(qty, focus) {
      if (!this.tiers.some(function (t) { return t.qty === qty; })) return;
      this.qty = qty;
      this.nextHint = -1;
      this.clearError();
      this.render();
      if (focus) {
        var el = this.tierEls.find(function (t) { return Number(t.dataset.qty) === qty; });
        if (el) el.focus();
      }
    }

    /* ---------- Pintado ---------- */

    render() {
      var self = this;
      var tier = this.currentTier();
      if (!tier) return;

      this.tierEls.forEach(function (el) {
        var on = Number(el.dataset.qty) === self.qty;
        el.setAttribute('aria-checked', on ? 'true' : 'false');
        el.tabIndex = on ? 0 : -1;
      });

      this.slotEls.forEach(function (el, i) {
        el.hidden = i >= self.qty;
        self.renderSlot(i);
      });

      var done = this.doneCount();
      this.countEl.textContent = done + ' / ' + tier.qty;

      var anchor = this.anchorUnit * tier.qty;
      var saving = anchor - tier.price;
      var isPack = tier.qty > 1;
      this.totalEl.textContent = money(tier.price, this.currency);
      this.anchorEl.hidden = !(isPack && saving > 0);
      this.anchorEl.innerHTML = '<span class="mpb-visually-hidden">Antes </span>' + money(anchor, this.currency);
      this.savingEl.hidden = !(isPack && saving > 0);
      this.savingEl.textContent = 'Ahorra ' + money(saving, this.currency);
      this.perUnitEl.hidden = !isPack;
      this.perUnitEl.textContent = money(tier.price / tier.qty, this.currency) + '/ud';
      if (this.codesNoteEl) this.codesNoteEl.hidden = !isPack;
      this.toggleKlaviyo(isPack);

      /* Unidad: ficha normal del tema. Pack: huecos y botón del pack. */
      this.classList.toggle('is-single', !isPack);
      this.syncNative();

      this.renderCta();
    }

    renderSlot(i) {
      var el = this.slotEls[i];
      var slot = this.slots[i];
      var product = slot.product != null ? this.products[slot.product] : null;
      var img = $(el, '[data-mpb-slot-img]');
      var sizeEl = $(el, '[data-mpb-slot-size]');
      var remove = $(el, '[data-mpb-slot-remove]');
      var open = $(el, '[data-mpb-slot-open]');

      el.classList.toggle('is-filled', !!product);
      el.classList.toggle('is-complete', this.isComplete(slot));
      el.classList.toggle('is-next', i === this.nextHint && !product);
      remove.hidden = !product;
      if (product) {
        if (product.thumb) {
          if (img.getAttribute('src') !== product.thumb) img.src = product.thumb;
          img.hidden = false;
        } else {
          img.hidden = true;
        }
        sizeEl.hidden = !this.hasSize;
        sizeEl.textContent = slot.size || 'Talla';
        sizeEl.classList.toggle('is-missing', !slot.size);
        open.setAttribute('aria-label', 'Hueco ' + (i + 1) + ': ' + product.color +
          (this.hasSize ? (slot.size ? ', talla ' + slot.size + '. Cambiar' : ', elige talla') : '. Cambiar'));
      } else {
        img.hidden = true;
        sizeEl.hidden = true;
        open.setAttribute('aria-label', 'Hueco ' + (i + 1) + ': elegir color y talla');
      }
    }

    renderCta() {
      if (this.busy) return;
      var tier = this.currentTier();
      var done = this.doneCount();
      if (done < tier.qty) {
        this.cta.setAttribute('aria-disabled', 'true');
        this.cta.textContent = tier.qty === 1 ? 'Elige tu talla' : 'Completa tu pack (' + done + '/' + tier.qty + ')';
      } else {
        this.cta.removeAttribute('aria-disabled');
        this.cta.textContent = (tier.qty === 1 ? 'Añadir al carrito · ' : 'Añadir pack · ') + money(tier.price, this.currency);
      }
    }

    showError(message) {
      this.errorEl.textContent = message;
      this.errorEl.hidden = false;
    }

    clearError() {
      if (!this.errorEl || this.errorEl.hidden) return;
      this.errorEl.hidden = true;
      this.errorEl.textContent = '';
    }

    setBusy(busy) {
      this.busy = busy;
      if (busy) {
        this.cta.setAttribute('aria-busy', 'true');
        this.cta.disabled = true;
        this.cta.textContent = 'Añadiendo…';
      } else {
        this.cta.removeAttribute('aria-busy');
        this.cta.disabled = false;
        this.renderCta();
      }
    }

    /* ---------- Ventana de color y talla ---------- */

    openDialog(slotIndex, opener) {
      if (!this.dialog) return;
      var slot = this.slots[slotIndex];
      var fallback = this.slots[0] && this.slots[0].product != null ? this.slots[0].product : this.currentIndex;
      this.dlg = {
        slot: slotIndex,
        product: slot.product != null ? slot.product : fallback,
        size: slot.size,
        image: 0
      };
      if (this.dlg.size && !this.sizeAvailable(this.dlg.product, this.dlg.size)) this.dlg.size = null;
      this.returnFocus = opener || $(this.slotEls[slotIndex], '[data-mpb-slot-open]');
      $(this.dialog, '[data-mpb-dialog-slot]').textContent = ' (hueco ' + (slotIndex + 1) + ')';
      this.renderDialog();
      this.dialog.showModal();
      document.documentElement.classList.add('mpb-lock');
      var first = $(this.dialog, '[data-mpb-color][aria-pressed="true"]') || $(this.dialog, '[data-mpb-dialog-close]');
      if (first) first.focus();
    }

    renderDialog() {
      var self = this;
      var d = this.dlg;
      var product = this.products[d.product];
      if (!product) return;
      var images = product.images && product.images.length ? product.images : (product.thumb ? [product.thumb] : []);
      if (d.image >= images.length) d.image = 0;
      var img = $(this.dialog, '[data-mpb-gallery-img]');
      if (images.length) {
        img.src = images[d.image];
        img.hidden = false;
      } else {
        img.removeAttribute('src');
        img.hidden = true;
      }
      img.alt = product.title + (images.length > 1 ? ', imagen ' + (d.image + 1) + ' de ' + images.length : '');
      $$(this.dialog, '[data-mpb-gallery-prev], [data-mpb-gallery-next]').forEach(function (b) { b.hidden = images.length < 2; });
      $(this.dialog, '[data-mpb-dialog-product]').textContent = product.title;

      $$(this.dialog, '[data-mpb-color]').forEach(function (btn) {
        var index = self.products.findIndex(function (p) { return p.id === Number(btn.dataset.productId); });
        var name = self.products[index] ? self.products[index].color : '';
        var stock = self.productAvailable(index);
        btn.setAttribute('aria-pressed', index === d.product ? 'true' : 'false');
        btn.classList.toggle('is-unavailable', !stock);
        btn.disabled = !stock;
        btn.setAttribute('aria-label', stock ? name : name + ', agotado');
        btn.title = stock ? name : name + ', agotado';
      });

      $$(this.dialog, '[data-mpb-size]').forEach(function (btn) {
        var value = btn.dataset.value;
        var ok = self.sizeAvailable(d.product, value);
        btn.disabled = !ok;
        btn.classList.toggle('is-unavailable', !ok);
        btn.setAttribute('aria-pressed', d.size === value ? 'true' : 'false');
        btn.setAttribute('aria-label', ok ? value : value + ', agotada');
      });

      var add = $(this.dialog, '[data-mpb-dialog-add]');
      add.disabled = !(this.hasSize ? d.size && this.sizeAvailable(d.product, d.size) : this.productAvailable(d.product));
    }

    confirmDialog() {
      var d = this.dlg;
      if (!d) return;
      this.slots[d.slot] = { product: d.product, size: this.hasSize ? d.size : null };
      this.normalize(this.slots[d.slot]);
      var next = this.firstIncomplete();
      this.nextHint = next;
      this.returnFocus = next >= 0 ? $(this.slotEls[next], '[data-mpb-slot-open]') : this.cta;
      this.clearError();
      this.render();
      this.dialog.close();
    }

    onDialogClose() {
      document.documentElement.classList.remove('mpb-lock');
      this.dlg = null;
      if (this.returnFocus && document.contains(this.returnFocus)) this.returnFocus.focus();
      this.returnFocus = null;
    }

    /* Clic en el fondo (fuera de la caja) cierra. */
    onDialogClick(event) {
      if (event.target === this.dialog) this.dialog.close();
    }

    /* ---------- Eventos ---------- */

    onClick(event) {
      var t = event.target;
      var el;

      if (this.dialog && this.dialog.contains(t)) {
        if (!this.dlg) return;
        if (t.closest('[data-mpb-dialog-close]')) { this.dialog.close(); return; }
        if ((el = t.closest('[data-mpb-color]')) && !el.disabled) {
          var id = Number(el.dataset.productId);
          this.dlg.product = this.products.findIndex(function (p) { return p.id === id; });
          this.dlg.image = 0;
          if (this.dlg.size && !this.sizeAvailable(this.dlg.product, this.dlg.size)) this.dlg.size = null;
          this.renderDialog();
          return;
        }
        if ((el = t.closest('[data-mpb-size]')) && !el.disabled) {
          this.dlg.size = el.dataset.value;
          this.renderDialog();
          return;
        }
        if (t.closest('[data-mpb-gallery-prev], [data-mpb-gallery-next]')) {
          var p = this.products[this.dlg.product];
          var n = Math.max(1, (p.images || []).length);
          this.dlg.image = (this.dlg.image + (t.closest('[data-mpb-gallery-next]') ? 1 : -1) + n) % n;
          this.renderDialog();
          return;
        }
        if ((el = t.closest('[data-mpb-dialog-add]')) && !el.disabled) this.confirmDialog();
        return;
      }

      if ((el = t.closest('[data-mpb-tier]'))) {
        this.setQty(Number(el.dataset.qty), false);
        return;
      }
      if ((el = t.closest('[data-mpb-slot-remove]'))) {
        var ri = this.slotEls.indexOf(el.closest('[data-mpb-slot]'));
        this.slots[ri] = { product: null, size: null };
        this.render();
        $(this.slotEls[ri], '[data-mpb-slot-open]').focus();
        return;
      }
      if ((el = t.closest('[data-mpb-slot-open]'))) {
        this.openDialog(this.slotEls.indexOf(el.closest('[data-mpb-slot]')), el);
        return;
      }
      if (t.closest('[data-mpb-cta]')) this.add();
    }

    onKeydown(event) {
      if (this.dialog && this.dialog.open && event.key === 'Tab') {
        this.trapFocus(event);
        return;
      }
      if (this.dialog && this.dialog.open && (event.key === 'ArrowLeft' || event.key === 'ArrowRight') &&
          event.target.closest('.mpb-gallery')) {
        event.preventDefault();
        var nav = $(this.dialog, event.key === 'ArrowLeft' ? '[data-mpb-gallery-prev]' : '[data-mpb-gallery-next]');
        if (nav && !nav.hidden) nav.click();
        return;
      }
      var tier = event.target.closest('[data-mpb-tier]');
      if (!tier) return;
      var index = this.tierEls.indexOf(tier);
      var next = null;
      switch (event.key) {
        case 'ArrowRight':
        case 'ArrowDown':
          next = (index + 1) % this.tierEls.length;
          break;
        case 'ArrowLeft':
        case 'ArrowUp':
          next = (index - 1 + this.tierEls.length) % this.tierEls.length;
          break;
        case 'Home':
          next = 0;
          break;
        case 'End':
          next = this.tierEls.length - 1;
          break;
        default:
          return;
      }
      event.preventDefault();
      this.setQty(Number(this.tierEls[next].dataset.qty), true);
    }

    /* El <dialog> modal ya deja inerte el resto de la página; esto cierra el ciclo del tabulador dentro. */
    trapFocus(event) {
      var focusables = $$(this.dialog, 'button:not([disabled]):not([hidden]), [href], [tabindex]:not([tabindex="-1"])')
        .filter(function (el) { return el.offsetParent !== null; });
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    /* ---------- Carrito ---------- */

    async add() {
      if (this.busy) return;
      var incomplete = this.firstIncomplete();
      if (incomplete >= 0) {
        this.openDialog(incomplete, this.cta);
        return;
      }

      var tier = this.currentTier();
      var packId = shortId();
      var grouped = {};
      var order = [];
      for (var u = 0; u < tier.qty; u++) {
        var variant = this.variantOf(this.slots[u].product, this.slots[u].size);
        if (!grouped[variant.id]) {
          grouped[variant.id] = 0;
          order.push(variant.id);
        }
        grouped[variant.id] += 1;
      }
      var items = order.map(function (id) {
        return { id: id, quantity: grouped[id], properties: { _pack: packId, _pack_size: String(tier.qty) } };
      });

      this.clearError();
      this.setBusy(true);
      try {
        var response = await fetch(routeRoot() + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ items: items })
        });
        var data = {};
        try { data = await response.json(); } catch (e) { data = {}; }

        if (!response.ok || data.status) {
          this.setBusy(false);
          this.showError(data.description || data.message || 'No hemos podido añadir el pack. Inténtalo de nuevo.');
          return;
        }

        this.dispatchEvent(new CustomEvent('macala:pack-added', {
          bubbles: true,
          detail: { packId: packId, packSize: tier.qty, items: items, cart: data }
        }));
        /* Igual que el bloque Pack Familiar del tema: avisa al carrito de Stiletto y lo abre. */
        document.dispatchEvent(new CustomEvent('apps:product-added-to-cart', {
          detail: { items: data.items || items }
        }));
        this.setBusy(false);
        var cartIcon = document.querySelector('[data-js-cart-icon]');
        if (cartIcon) cartIcon.click();
        else window.location.href = routeRoot() + 'cart';
      } catch (error) {
        this.setBusy(false);
        this.showError('No hemos podido conectar con la tienda. Revisa tu conexión e inténtalo de nuevo.');
      }
    }
  }

  window.customElements.define('macala-pack-builder', MacalaPackBuilder);
})();
